(function($)
{
    $(function()
    {
        $('.user-navigation-link').each(function(){
            var metadata = $(document.body).metadata();
            var postResolution = false;
            if(!metadata.sw) {
                postResolution = true;
            }
            else {
                var browserWidth = $(window).width();
                var browserHeight = $(window).height();
                var screenWidth = screen.width;
                var screenHeight = screen.height;
                if(browserWidth != metadata.bw || browserHeight != metadata.bh || screenWidth != metadata.sw || screenHeight != metadata.sh) {
                    postResolution = true;
                }
            }
            if(postResolution) {
                _postResolution();
            }

            // post the resolution in response to user resizing browser.
            // If the user drags the browser edge then multiple event will fire so use a timeout to only respond to the last.
            var timeout;
            $(window).resize(function(){
                clearTimeout(timeout);
                timeout = setTimeout(function(){
                    _postResolution();
                },1000);
            });
        });

        function _postResolution() {
            var browserWidth = $(window).width();
            var browserHeight = $(window).height();
            var screenWidth = screen.width;
            var screenHeight = screen.height;

            if (browserWidth != undefined && browserHeight != undefined && screenWidth != undefined && screenHeight != undefined) {
                $.post('/fpm/session/resolution',
                    {
                        'browserWidth': browserWidth,
                        'browserHeight': browserHeight,
                        'screenWidth': screenWidth,
                        'screenHeight': screenHeight
                    }
                );
            }
        }
    });
})(jQuery);